import { defineModule } from '@berky/module-contract'

/**
 * Das Manifest ist die einzige Verbindung zwischen Modul und Shell.
 * Die Shell findet diese Datei selbst — sie muss nirgends eingetragen werden.
 */
export default defineModule({
  id: 'maehboot-versenken',
  title: 'Mähboot-Versenken',
  description: 'Rundenbasiertes Mähboot-Versenken gegen andere Nutzer.',
  icon: 'Ship',
  order: 20,
  apiBasePath: '/api/maehboot-versenken',

  // Dieselbe Rolle, die das Backend über IProvidesRoles anmeldet. Sie steuert
  // beides: die Sichtbarkeit in der Navigation und wen man als Gegner sieht.
  roles: ['maehboot-versenken.spieler'],

  routes: () => import('./src/routes'),

  // Optional: eine Kennzahl für die Kachel auf der Startseite.
  // homeWidget: () => import('./src/home-widget'),
})
